import { Button } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { AxiosResponse } from "axios";
import React, { memo, useEffect, useRef, useState } from "react";
import { AiOutlineClose, AiOutlineUpload } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { savePdfUrls } from "../../../Redux/Actions/Index";
import RequisitionType from "../../../Services/Requisition/RequisitionTypeService";
import LoadButton from "../../../Shared/Common/LoadButton";
import { Loader } from "../../../Shared/Common/Loader";
import PermissionComponent, {
  PermissionObject,
} from "../../../Shared/Common/Permissions/PermissionComponent";
import { useResultDataContext } from "../../../Shared/OncologyResultDataContext";
import useLang from "Shared/hooks/useLanguage";

interface ExpandableI {
  row: any;
  requisitionId: number;
  reqTypeId: number;
  requisitionOrderId: number;
  PathogensList: any[];
  facilityId: number;
  panelId: number;
}

export const ampStatusDropDown = [
  {
    value: "amp",
    label: "Amp",
  },
  {
    value: "no amp",
    label: "No Amp",
  },
];

const ResultDataExpandableRow = (props: ExpandableI) => {
  const {
    row,
    requisitionId,
    reqTypeId,
    requisitionOrderId,
    PathogensList,
    facilityId,
    panelId,
  } = props;

  const initialMainCheckboxes = {
    controlCheckbox: [],
    organismCheckbox: [],
    resistanceCheckbox: [],
  };

  const {
    data,
    loadGridData,
    filterData,
    rowsToExpand,
    setRowsToExpand,
    isMasterExpandTriggered,
  } = useResultDataContext();

  const { t } = useLang();

  const dispatch = useDispatch();
  const rowExpandKey = `${row?.requisitionOrderId}_${row?.panelID}`;
  const [bar, setBar] = useState(false);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isPublishing, setIsPublishing] = useState(false);
  const [isValidating, setIsValidating] = useState(false);
  const [isUnPublishing, setIsUnPublishing] = useState(false);
  const [isSendingToApi, setIsSendingToApi] = useState(false);
  const [isPreviewing, setIsPreviewing] = useState(false);
  const [mControlsList, setMControlsList] = useState<any>([]);
  const [isReRunCheckBox, setIsReRunCheckBox] = useState(false);
  const [mPathogensList, setMPathogensList] = useState<any>([]);
  const [mainCheckboxes, setMainCheckboxes] = useState(initialMainCheckboxes);
  const [showCtValueError, setShowCtValueError] = useState(false);
  const [resultSummaryRows, setResultSummaryRows] = useState([
    {
      fieldKey: "isNettest20Score",
      test: "NETtest 2.0 Score",
      result: "",
      interpretation: "",
    },
    {
      fieldKey: "isProgressionScore",
      test: "Progression Score",
      result: "",
      interpretation: "",
    },
    {
      fieldKey: "isPPQScore",
      test: "PPQ Score",
      result: "",
      interpretation: "",
    },
  ]);
  const [finalResult, setFinalResult] = useState<any>("");
  const [isSentToApi, setIsSentToApi] = useState(false);
  const [DupisSentToApi, setDupIsSentToApi] = useState(false);
  const targetRef = useRef(null);
  const [reportNotes, setReportNotes] = useState<any>({
    lisNotes: "",
    criticalReport: "",
  });
  const [fieldStatus, setFieldStatus] = useState<any>({
    isNettest20Score: false,
    isProgressionScore: false,
    isPPQScore: false,
  });
  const [reportCheckboxes, setReportCheckboxes] = useState({
    isCorrected: false,
    isAmended: false,
  });

  const allowedKeys: string[] = [
    "Backspace",
    "Tab",
    "+",
    "-",
    "ArrowUp",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight",
  ];
  const ModalhandleClose = () => setShow(false);

  const normalizeLisStatus = (s: string | undefined) =>
    (s ?? "").trim().toLowerCase();
  const LIS_READY_TO_PUBLISH = "ready to publish";
  const LIS_READY_TO_VALIDATE = "ready to validate";

  const isNumericKey = (key: string): boolean => {
    return /^[0-9.]$/.test(key) || allowedKeys.includes(key);
  };

  const changeControlsStatus = (Status: string) => {
    const r = {
      status: Status,
      controls: mControlsList,
    };
    RequisitionType.ChangeControlStatusOncology(r)
      .then((res: AxiosResponse) => {
        if (res?.data.statusCode === 200) {
          toast.success(t(res?.data?.message));
          GetExpandDataById(requisitionOrderId, panelId);
        }
      })
      .catch((err: any) => {
        console.trace(err);
      });
  };

  const ChangeOrganismStatus = (
    status: string,
    item: any,
    itemIndex: number
  ): void => {
    const shouldUpdateCtValue = (
      ctValue: string | null | undefined,
      status: string
    ): boolean => {
      if (status === "Invalid") {
        return true; // Update all values for Invalid
      }
      return ctValue === "" || ctValue === null; // Only update empty/null for other statuses
    };

    const updateCtValues = (items: any[], newCtValue: string): any[] => {
      return items?.map((data: any) => ({
        ...data,
        ctValue: shouldUpdateCtValue(data.ctValue, newCtValue)
          ? newCtValue
          : data.ctValue,
      }));
    };

    const updatePathogensListLocally = (newCtValue: string): void => {
      const updatedPathogensList = [...mPathogensList];
      const currentItem = updatedPathogensList[itemIndex];

      updatedPathogensList[itemIndex] = {
        ...currentItem,
        resistance: updateCtValues(currentItem.resistance, newCtValue),
        organisms: updateCtValues(currentItem.organisms, newCtValue),
      };

      setMPathogensList(updatedPathogensList);
    };

    const updateStatusViaApi = async (): Promise<void> => {
      const requestPayload = {
        status,
        pathogens: item,
      };

      try {
        const response =
          await RequisitionType.ChangeOrganismStatusOncology(requestPayload);

        if (response?.data?.statusCode === 200) {
          toast.success(t(response.data.message));
          await GetExpandDataById(requisitionOrderId, panelId);
        }
      } catch (error) {
        console.error("Error changing organism status:", error);
      }
    };

    // Main logic
    if (status === "Undetermined" || status === "Invalid") {
      updatePathogensListLocally(status);
    } else {
      updateStatusViaApi();
    }
  };

  const SendResultToApi = () => {
    const foundRecord = data?.gridData?.data?.data?.find(
      (item: any) => item?.requisitionOrderId === requisitionOrderId && item?.panelID === panelId
    );
    if (
      foundRecord.lisStatus.toLowerCase() !== "ready for api"
    ) {
      return toast.error(t("Status is not ready for API"));
    }
    setIsSendingToApi(true);

    const payload = {
      panelId: panelId,
      requisitionOrderId: requisitionOrderId
    }
    RequisitionType.SendOncologyResultToApi(payload)
      .then((res: AxiosResponse) => {
        if (res?.data?.statusCode === 200) {
          toast.success(t(res?.data?.message));
          loadGridData(false);
          GetExpandDataById(requisitionOrderId, panelId);
        } else if (res?.data?.statusCode === 400) {
          toast.error(t(res?.data?.message));
        }
      })
      .catch((err: any) => {
        console.trace(err);
        toast.error(t("Something went wrong while sending to API."));
      })
      .finally(() => {
        setIsSendingToApi(false);
      });
  };

  const SaveIdResultDataExpand = () => {
    const getSummaryResult = (fieldKey: string) =>
      resultSummaryRows.find((item: any) => item.fieldKey === fieldKey)?.result ??
      "";

    const row = {
      requisitionOrderId: requisitionOrderId,
      controls: mControlsList,
      pathogens: mPathogensList,
      lisNotes: reportNotes?.lisNotes,
      criticalReport: reportNotes?.criticalReport,
      ccFaxNumbers: "",
      panelId: panelId,
      finalResult: finalResult,
      isSentToApi: isSentToApi,
      netestScore: getSummaryResult("isNettest20Score"),
      progressionScore: getSummaryResult("isProgressionScore"),
      ppqScore: getSummaryResult("isPPQScore"),
    };
    setIsSubmitting(true);
    RequisitionType.SaveIdResultDataExpandOncology(row)
      .then(async (res: AxiosResponse) => {
        if (res?.data.statusCode === 200) {
          toast.success(t(res?.data?.message));
          setIsSubmitting(false);
          await loadGridData(false);
          GetExpandDataById(requisitionOrderId, panelId);
        }
      })
      .catch((err: any) => {
        setIsSubmitting(false);
        console.trace(err);
      });
  };

  const ApplyRerun = () => {
    const row = {
      requisitionOrderId: requisitionOrderId,
      reqTypeId: reqTypeId,
      controls: mControlsList,
      pathogens: mPathogensList,

    };
    setIsReRunCheckBox(true);
    RequisitionType.ApplyRerunOncology(row)
      .then(async (res: AxiosResponse) => {
        if (res?.data.statusCode === 200) {
          toast.success(t(res?.data?.message));
          await loadGridData(false);
          GetExpandDataById(requisitionOrderId, panelId);
        }
      })
      .catch((err: any) => {
        console.trace(err);
      })
      .finally(() => {
        setIsReRunCheckBox(false);
        setBar(false);
        setMainCheckboxes(initialMainCheckboxes);
      });
  };

  const GenerateBlanksAgainstReqOrderId = () => {
    RequisitionType.GenerateBlanksAgainstReqOrderId(requisitionOrderId)
      .then((res: AxiosResponse) => {
        if (res?.data.statusCode === 200) {
          toast.success(t(res?.data?.message));
          GetExpandDataById(requisitionOrderId, panelId);
        }
      })
      .catch((err: any) => {
        console.trace(err);
      });
  };

  const handleFieldChange = (
    panelIndex: any,
    Index: any,
    field: any,
    value: any,
    type: string
  ) => {
    const updatedPathogensList = [...mPathogensList];
    if (type === "resistance") {
      const resistanceToUpdate =
        updatedPathogensList[panelIndex]?.resistance?.[Index];
      if (resistanceToUpdate) {
        if (field === "isReRun") {
          setMainCheckboxes((pre: any) => {
            return {
              ...pre,
              resistanceCheckbox: [
                ...pre.resistanceCheckbox,
                resistanceToUpdate.id,
              ],
            };
          });
        }
        resistanceToUpdate[field] = value;
        if (field === "isReRun" && value === false) {
          setMainCheckboxes((prev: any) => {
            return {
              ...prev,
              resistanceCheckbox: prev.resistanceCheckbox.filter(
                (id: any) => id !== resistanceToUpdate.id
              ),
            };
          });
        }
      }
    } else {
      const organismToUpdate =
        updatedPathogensList[panelIndex]?.organisms?.[Index];
      if (organismToUpdate) {
        if (field === "isReRun") {
          setMainCheckboxes((pre: any) => {
            return {
              ...pre,
              organismCheckbox: [...pre.organismCheckbox, organismToUpdate.id],
            };
          });
        }
        organismToUpdate[field] = value === "" ? null : value;
        if (field === "isReRun" && value === false) {
          setMainCheckboxes((prev: any) => {
            return {
              ...prev,
              organismCheckbox: prev.organismCheckbox.filter(
                (id: any) => id !== organismToUpdate.id
              ),
            };
          });
        }
      }
    }

    setMPathogensList(updatedPathogensList);
  };

  const OncologyLISReportView = (
    reqId: any,
    reqType: any,
    facilityId: any,
    requisitionOrderId: any
  ) => {
    const row = {
      reqId: reqId,
      requisitionOrderId: requisitionOrderId,
      templateId: "",
      reqType: reqType,
      facilityId: facilityId,
      isPreview: true,
      panelId: panelId,
    };
    setIsPreviewing(true);
    RequisitionType.OncologyLISReportView(row)
      .then((res: AxiosResponse) => {
        if (res?.data.statusCode === 200) {
          toast.success(t(res?.data?.message));
          setIsPreviewing(false);
          dispatch(savePdfUrls(res?.data?.data));
          window.open("/docs-viewer", "_blank", "noreferrer");
        }
        if (res?.data.statusCode === 400) {
          toast.error(t(res?.data?.message));
          setIsPreviewing(false);
        }
      })
      .catch((err: any) => {
        console.trace(err);
      });
  };

  const Validate = async (
    reqId: any,
    reqType: any,
    facilityId: any,
    requisitionOrderId: any
  ) => {
    setIsValidating(true);
    try {
      const foundRecord = data?.gridData?.data?.data?.find(
        (item: any) =>
          item?.requisitionId === reqId &&
          item?.requisitionOrderId === requisitionOrderId &&
          item?.panelID === panelId
      );
      if (!foundRecord) {
        toast.error(t("Record not found"));
        return;
      }
      const lisStatus = normalizeLisStatus(foundRecord?.lisStatus);
      if (lisStatus === "pending" || lisStatus === "pending abr") {
        return toast.error(t("Result is not completed in all tests"));
      }
      if (lisStatus === "pending pharmd") {
        return toast.error(t("Result is not completed due to Pending PharmD"));
      }
      if (lisStatus !== LIS_READY_TO_VALIDATE) {
        return toast.error(t("Status is not ready to validate"));
      }
      const publishObj = {
        requisitionOrderId: requisitionOrderId,
        panelId: panelId,
      };
      const publishRes: AxiosResponse =
        await RequisitionType.ValidateOncology(publishObj);
      if (publishRes?.data?.statusCode === 200) {
        toast.success(t(publishRes?.data?.message));
        loadGridData(false);
      } else if (publishRes?.data?.statusCode === 400) {
        toast.info(t(publishRes?.data?.message));
      }
    } catch (err) {
      console.trace(err);
      toast.error(t("Something went wrong during validation."));
    } finally {
      setIsValidating(false);
    }
  };


  const Publish = async (
    reqId: any,
    reqType: any,
    facilityId: any,
    requisitionOrderId: any
  ) => {
    setIsPublishing(true);
    try {
      const foundRecord = data?.gridData?.data?.data?.find(
        (item: any) =>
          item?.requisitionId === reqId &&
          item?.requisitionOrderId === requisitionOrderId &&
          item?.panelID === panelId
      );
      if (!foundRecord) {
        toast.error(t("Record not found"));
        return;
      }
      const lisStatus = normalizeLisStatus(foundRecord?.lisStatus);
      if (lisStatus === "pending" || lisStatus === "pending abr") {
        return toast.error(t("Result is not completed in all tests"));
      }
      if (lisStatus === "pending pharmd") {
        return toast.error(t("Result is not completed due to Pending PharmD"));
      }
      if (lisStatus !== LIS_READY_TO_PUBLISH) {
        return toast.error(t("Status is not ready to publish"));
      }
      const publishObj = {
        requisitionOrderId: requisitionOrderId,
        panelId: panelId,
      };
      const publishRes: AxiosResponse =
        await RequisitionType.PublishOncology(publishObj);
      if (publishRes?.data?.statusCode === 200) {
        toast.success(t(publishRes?.data?.message));
        loadGridData(false);
      } else if (publishRes?.data?.statusCode === 400) {
        toast.info(t(publishRes?.data?.message));
      }
    } catch (err) {
      console.trace(err);
      toast.error(t("Something went wrong during publishing."));
    } finally {
      setIsPublishing(false);
    }
  };

  const UnPublishAndValidate = async () => {
    setIsUnPublishing(true);
    try {
      const res: any = await RequisitionType.UnvalidateResultDataOncology([
        {
          panelId: panelId,
          requisitionOrderId: requisitionOrderId,
        },
      ]);
      if (res.status === 200) {
        toast.success(t(res.data?.message ?? "Request Successfully Processed"));
        await loadGridData(false);
        GetExpandDataById(requisitionOrderId, panelId);
      } else {
        toast.error(t(res.data?.message));
      }
    } catch (err: any) {
      console.error(err);
      toast.error(t("An error occurred while processing the request"));
    } finally {
      setIsUnPublishing(false);
    }
  };

  const handleControlsFieldChange = (
    controlsIndex: any,
    field: any,
    value: any
  ) => {
    const updatedControlsList = [...mControlsList];
    const controlsToUpdate = updatedControlsList?.[controlsIndex];

    if (controlsToUpdate) {
      controlsToUpdate[field] = value;
      if (field === "isReRun") {
        if (value) {
          setMainCheckboxes((pre: any) => {
            return {
              ...pre,
              controlCheckbox: [...pre.controlCheckbox, controlsToUpdate.id],
            };
          });
        } else {
          setMainCheckboxes((prev: any) => {
            return {
              ...prev,
              controlCheckbox: prev.controlCheckbox.filter(
                (id: any) => id !== controlsToUpdate.id
              ),
            };
          });
        }
      }
    }

    setMControlsList(updatedControlsList);
  };

  const handleSetReRunControlsForAll = (value: boolean) => {
    const updatedControlsList = [...mControlsList];
    setMainCheckboxes((pre: any) => {
      return {
        ...pre,
        controlCheckbox: value ? updatedControlsList.map((item) => item.id) : [],
      };
    });

    updatedControlsList.forEach((item) => {
      item.isReRun = value;
    });

    setMControlsList(updatedControlsList);
  };
  const handleSetReRunForAll = (
    value: boolean,
    itemIndex: number,
    type: string
  ) => {
    const updatedPathogensList = [...mPathogensList];
    if (updatedPathogensList[itemIndex]) {
      if (type === "resistance") {
        updatedPathogensList[itemIndex].resistance = updatedPathogensList[
          itemIndex
        ].resistance?.map((data: any) => ({
          ...data,
          isReRun: value,
        }));

        if (value) {
          setMainCheckboxes((pre: any) => {
            return {
              ...pre,
              resistanceCheckbox: updatedPathogensList[
                itemIndex
              ].resistance.map((item: any) => item.id),
            };
          });
        } else {
          setMainCheckboxes((pre: any) => {
            return {
              ...pre,
              resistanceCheckbox: [],
            };
          });
        }
      } else {
        updatedPathogensList[itemIndex].organisms = updatedPathogensList[
          itemIndex
        ].organisms?.map((data: any) => ({
          ...data,
          isReRun: value,
        }));

        if (value) {
          setMainCheckboxes((pre: any) => {
            return {
              ...pre,
              organismCheckbox: updatedPathogensList[itemIndex].organisms?.map(
                (item: any) => item.id
              ),
            };
          });
        } else {
          setMainCheckboxes((pre: any) => {
            return {
              ...pre,
              organismCheckbox: [],
            };
          });
        }
      }

      // Update the state with the modified pathogens list
      setMPathogensList(updatedPathogensList);
    }
  };

  const handleFieldChangeTextArea = (value: any, names: any) => {
    if (names === "lisNotes") {
      setReportNotes((prev: any) => ({ ...prev, lisNotes: value }));
    } else {
      setReportNotes((prev: any) => ({ ...prev, criticalReport: value }));
    }
  };

  const handleResultSummaryChange = (fieldKey: string, value: string) => {
    setIsSentToApi(false);
    setResultSummaryRows((prev) =>
      prev.map((row: any) =>
        row.fieldKey === fieldKey ? { ...row, result: value } : row
      )
    );
  };

  // Start IXpress condtion on the base on Upload
  const permissions = useSelector(
    (state: any) =>
      state?.Reducer?.selectedTenantInfo?.infomationOfLoggedUser?.permissions ||
      []
  );

  const hasPermission = permissions.some(
    (permission: PermissionObject) =>
      permission.subject.replace(/\n/g, "").toLowerCase() ===
      "Result Data".replace(/\n/g, "").toLowerCase() &&
      permission.moduleName.replace(/\n/g, "").toLowerCase() ===
      "ID LIS".replace(/\n/g, "").toLowerCase() &&
      permission.action.replace(/\n/g, "").toLowerCase() ===
      "FileUpload".replace(/\n/g, "").toLowerCase()
  );
  // End IXpress condtion on the base on Upload

  const GetExpandDataById = (requisitionOrderId: any, panelId: any) => {
    setLoading(true);
    const obj = {
      panelId: panelId,
      requisitionOrderId: requisitionOrderId
    }
    RequisitionType.GetOncologyExpandDataById(obj)
      .then((res: any) => {
        const responseData = res?.data?.data ?? {};
        setFinalResult(res?.data?.data?.finalResult);
        setIsSentToApi(res?.data?.data?.isSentToApi);
        setDupIsSentToApi(res?.data?.data?.isSentToApi);
        setFieldStatus({
          isNettest20Score: res?.data?.data?.isShowNetestScore,
          isProgressionScore: res?.data?.data?.isShowProgressionScore,
          isPPQScore: res?.data?.data?.isShowPPQScore,
        });
        setResultSummaryRows((prev: any) =>
          prev.map((summaryRow: any) => {
            if (summaryRow.fieldKey === "isNettest20Score") {
              return {
                ...summaryRow,
                result: responseData?.netestScore ?? "",
                interpretation: responseData?.netestInterpretation ?? "",
              };
            }
            if (summaryRow.fieldKey === "isProgressionScore") {
              return {
                ...summaryRow,
                result: responseData?.progressionScore ?? "",
                interpretation: responseData?.progressionInterpretation ?? "",
              };
            }
            if (summaryRow.fieldKey === "isPPQScore") {
              return {
                ...summaryRow,
                result: responseData?.ppqScore ?? "",
                interpretation: responseData?.ppqInterpretation ?? "",
              };
            }
            return summaryRow;
          })
        );
        setMControlsList(res?.data?.data?.controls);
        setMPathogensList(res?.data?.data?.pathogens);
        setReportNotes({
          lisNotes: res?.data?.data?.lisNotes,
          criticalReport: res?.data?.data?.criticalReport,
        });
        setReportCheckboxes({
          isAmended: res?.data?.data?.isAmended,
          isCorrected: res?.data?.data?.isCorrected,
        });
        setLoading(false);
      })
      .catch((err: any) => {
        console.trace(err, "err");
        setLoading(false);
      });
  };

  useEffect(() => {
    GetExpandDataById(requisitionOrderId, panelId);
  }, []);

  useEffect(() => {
    setMPathogensList(PathogensList);
  }, [PathogensList]);

  useEffect(() => {
    const { organismCheckbox, resistanceCheckbox, controlCheckbox } =
      mainCheckboxes;
    setBar(
      organismCheckbox.length > 0 ||
      resistanceCheckbox.length > 0 ||
      controlCheckbox.length > 0
    );
  }, [mainCheckboxes]);

  useEffect(() => {
    if (!targetRef.current || !isMasterExpandTriggered) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          // setIsVisible(true);
          const allData = data.gridData.data.data;
          const lastElement = String(rowsToExpand[rowsToExpand.length - 1]);

          const lastIndex = allData.findIndex(
            (item: any) =>
              `${item.requisitionOrderId}_${item.panelID}` === lastElement
          );

          // Get next 5 elements after lastElement
          const nextFiveIds = allData
            .slice(lastIndex + 1, lastIndex + 4)
            .map((item: any) => `${item.requisitionOrderId}_${item.panelID}`);

          setRowsToExpand((prev: any) => [...prev, ...nextFiveIds]);

          observer.unobserve(entry.target);
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      }
    );

    observer.observe(targetRef.current);

    return () => {
      observer.disconnect();
    };
  }, [targetRef.current]);

  const [file, setFile] = useState<File | null>(null);
  const [uploading, setUploading] = useState(false);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  const handleRemoveFile = () => {
    setFile(null);
  };

  const handleUpload = async () => {
    if (!file) return;
    setUploading(true);

    try {
      const formData = new FormData()

      // Append all other fields
      formData.append("ReqId", row?.requisitionId);
      formData.append("RequisitionOrderId", row?.requisitionOrderId);
      formData.append("ReqType", row?.requisitionTypeId);
      formData.append("FacilityId", row?.facilityId);
      formData.append("File", file);

      const response = await RequisitionType.fileUpload(formData);

      if (response?.data?.statusCode === 400) {
        toast.error(t(response?.data?.message));
      } else {
        toast.success(t(response?.data?.message));
      }

      setFile(null);
    } catch (error) {
      console.error(error);
      alert("Upload failed!");
    } finally {
      setUploading(false);
    }
  };

  const hasCtValue = (value: any) =>
    value !== null &&
    value !== undefined &&
    String(value).trim() !== "";

  const isCtScoreCompletedInAllPanels =
    mPathogensList?.length > 0 &&
    mPathogensList.every((panel: any) => {
      const organismRows = panel?.organisms ?? [];
      const resistanceRows = panel?.resistance ?? [];
      const panelRows = [...organismRows, ...resistanceRows];

      if (panelRows.length === 0) return false;

      return panelRows.every((row: any) => hasCtValue(row?.ctValue));
    });

  const visibleResultSummaryRows = resultSummaryRows.filter(
    (summaryRow: any) => fieldStatus?.[summaryRow.fieldKey]
  );

  const handleEditFinalScore = () => {
    if (!isCtScoreCompletedInAllPanels) {
      setShowCtValueError(true);
      toast.error(t("CT score is not completed in all panels"));
      return;
    }
    setShowCtValueError(false);
    setIsSentToApi(false);
  };

  const isResultFieldEditable =
    filterData.tabId !== 2 && (!isSentToApi || isCtScoreCompletedInAllPanels);
  console.log(visibleResultSummaryRows, "visibleResultSummaryRows")
  return (
    <div
      ref={
        rowsToExpand.length > 0 &&
          rowExpandKey === String(rowsToExpand[rowsToExpand.length - 2])
          ? targetRef
          : null
      }
      className="d-flex flex-column flex-column-fluid table-expend-sticky table-expend-sm-sticky"
    >
      <div id="kt_app_content" className="app-content flex-column-fluid pb-0">
        <div
          id="kt_app_content_container"
          className="app-container container-fluid mb-container"
        >
          <div className="d-flex flex-wrap gap-3 justify-content-center justify-content-sm-between align-items-center mt-3">
            <div className="align-items-center d-flex mb-md-3 mb-3 gap-2 flex-wrap">
              {filterData.tabId === 1 ? (
                <PermissionComponent
                  moduleName="ID LIS"
                  pageName="Result Data"
                  permissionIdentifier="PublishandValidate"
                >
                  <div className="d-flex gap-2">

                    <LoadButton
                      id={`ResultDataExpandSaveButton`}
                      className="btn btn-primary btn-sm fw-bold search d-block fs-12px h-30px py-0 fw-500"
                      loading={isSubmitting}
                      btnText={t("Save")}
                      loadingText={t("Saving")}
                      onClick={() => SaveIdResultDataExpand()}
                    />

                    <LoadButton
                      id={`ResultDataExpandPublish`}
                      className="btn btn-success btn-sm fw-bold search d-block fs-12px h-30px py-0 fw-500"
                      loading={isPublishing}
                      btnText={t("Publish")}
                      loadingText={t("Processing.....")}
                      onClick={async () => {
                        if (
                          hasPermission === true &&
                          row?.graphImageFileBit === false
                        ) {
                          setShow(true);
                        } else {
                          await Publish(
                            requisitionId,
                            reqTypeId,
                            facilityId,
                            row?.requisitionOrderId
                          );
                        }
                      }}
                    />
                    <LoadButton
                      id={`ResultDataExpandValidate`}
                      className="btn btn-success btn-sm fw-bold search d-block fs-12px h-30px py-0 fw-500"
                      loading={isValidating}
                      btnText={t("Validate")}
                      loadingText={t("Processing.....")}
                      onClick={async () => {
                        if (
                          hasPermission === true &&
                          row?.graphImageFileBit === false
                        ) {
                          setShow(true);
                        } else {
                          await Validate(
                            requisitionId,
                            reqTypeId,
                            facilityId,
                            row?.requisitionOrderId
                          );
                        }
                      }}
                    />
                  </div>
                </PermissionComponent>
              ) : null}
              {filterData.tabId === 2 ? (
                <PermissionComponent
                  moduleName="Oncology LIS"
                  pageName="Result Data"
                  permissionIdentifier="UnPublishandValidate"
                >
                  <LoadButton
                    id={`ResultDataExpandUnPublishValidate`}
                    className="btn btn-secondary btn-sm fw-bold search d-block fs-12px h-30px py-0 fw-500"
                    loading={isUnPublishing}
                    btnText={t("UnPublish & Validate")}
                    loadingText={t("Processing.....")}
                    onClick={() => UnPublishAndValidate()}
                  />
                </PermissionComponent>
              ) : null}
              <PermissionComponent
                moduleName="ID LIS"
                pageName="Result Data"
                permissionIdentifier="Preview"
              >
                <LoadButton
                  id={`ResultDataExpandPreviewButton`}
                  className="btn btn-warning btn-sm fw-bold search d-block fs-12px h-30px py-0 fw-500 text-white"
                  loading={isPreviewing}
                  btnText={t("Preview")}
                  loadingText={t("Previewing")}
                  onClick={() =>
                    OncologyLISReportView(
                      requisitionId,
                      reqTypeId,
                      facilityId,
                      row.requisitionOrderId
                    )
                  }
                />
              </PermissionComponent>
              <PermissionComponent
                moduleName="Oncology LIS"
                pageName="Result Data"
                permissionIdentifier="Save"
              >
                <LoadButton
                  id={`ResultDataExpandSaveButton`}
                  className="btn btn-primary btn-sm fw-bold search d-block fs-12px h-30px py-0 fw-500"
                  loading={isSubmitting}
                  btnText={t("Save")}
                  loadingText={t("Saving")}
                  onClick={() => SaveIdResultDataExpand()}
                />
              </PermissionComponent>
              {filterData.tabId === 1 ? (
                <PermissionComponent
                  moduleName="ID LIS"
                  pageName="Result Data"
                  permissionIdentifier="Save"
                >
                  <div className="d-flex flex-column">
                    <div className="d-flex gap-2">
                      {DupisSentToApi ? (
                        <LoadButton
                          id="ResultDataExpandSendToApi"
                          className="btn btn-outline-primary btn-sm fw-bold search d-block fs-12px h-30px py-0 fw-500"
                          loading={isSendingToApi}
                          btnText={t("Send to API")}
                          loadingText={t("Sending...")}
                          onClick={() => SendResultToApi()}
                        />
                      ) : null}
                      <button
                        id="ResultDataExpandEditFinalScore"
                        className="btn btn-warning btn-sm fw-bold search d-block fs-12px h-30px py-0 fw-500"
                        onClick={handleEditFinalScore}
                        disabled={!isSentToApi}
                      >
                        {t("Edit Final Score")}
                      </button>
                    </div>
                    {showCtValueError && !isCtScoreCompletedInAllPanels ? (
                      <span className="text-danger fs-12px mt-1">
                        {t("CT value is not completed in all panels")}
                      </span>
                    ) : null}
                  </div>
                </PermissionComponent>
              ) : null}
              {filterData.tabId === 1 || filterData.tabId === 2 ? (
                <div>
                  {!file ? (
                    <>
                      <input
                        type="file"
                        id="hiddenFileInput"
                        accept=".png,.jpg"
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                      />
                      <PermissionComponent
                        moduleName="ID LIS"
                        pageName="Result Data"
                        permissionIdentifier="FileUpload"
                      >
                        <LoadButton
                          className="btn btn-danger btn-sm fw-bold search d-block fs-12px h-30px py-0 fw-500"
                          loading={uploading}
                          btnText={t("File Upload")}
                          loadingText={t("Uploading...")}
                          onClick={() =>
                            document.getElementById("hiddenFileInput")?.click()
                          }
                        />
                      </PermissionComponent>
                    </>
                  ) : (
                    <div
                      style={{
                        backgroundColor: "#f8f9fa",
                        padding: "8px 12px",
                        borderRadius: "6px",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <span
                        style={{
                          flex: 1,
                          fontSize: "14px",
                          wordBreak: "break-word",
                        }}
                      >
                        {file.name}
                      </span>
                      <Button
                        variant="outlined"
                        color="error"
                        size="small"
                        sx={{ minWidth: "30px" }}
                        onClick={handleRemoveFile}
                      >
                        <AiOutlineClose size={16} />
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={handleUpload}
                        disabled={uploading}
                        startIcon={<AiOutlineUpload />}
                      >
                        {uploading ? t("Uploading...") : t("Upload")}
                      </Button>
                    </div>
                  )}
                </div>
              ) : null}
              {bar ? (
                <LoadButton
                  className="btn btn-info btn-sm fw-bold search d-block fs-12px h-30px py-0 fw-500"
                  loading={isReRunCheckBox}
                  btnText={t("Apply ReRun")}
                  loadingText={t("Applying")}
                  onClick={() => ApplyRerun()}
                />
              ) : null}

            </div>
            <div className="d-flex align-items-center gap-2 gap-lg-3 mb-2">
              {loading ? null : mPathogensList?.length === 0 ? (
                <button
                  id="ResultDataExpandCreatManualResult"
                  onClick={() => GenerateBlanksAgainstReqOrderId()}
                  className="btn btn-linkedin btn-sm fs-12px h-30px py-0 fw-500"
                  aria-controls="Search"
                >
                  {t(" + Create Manual Results")}
                </button>
              ) : null}
            </div>
          </div>
          <div
            className="col-xl-12 col-lg-12 col-md-12 col-sm-12 rounded mb-4"
            style={{ border: "2px solid #ffc700" }}
          >
            <div className="card mb-4 border">
              <div className="card-header bg-light-warning d-flex justify-content-between align-items-center px-4 min-h-40px">
                <h5 className="m-0 text-warning">{t("Result Summary")}</h5>
              </div>
              <div className="card-body py-md-4 py-3 px-4">
                <div className="table_bordered overflow-hidden">
                  <TableContainer className="shadow-none">
                    <Table
                      stickyHeader
                      aria-label="sticky table collapsible"
                      className="plate-mapping-table mb-1"
                    >
                      <TableHead className="h-35px">
                        <TableRow>
                          <TableCell className="min-w-250px w-250px">
                            {t("Test")}
                          </TableCell>
                          <TableCell className="min-w-200px w-200px">
                            {t("Result")}
                          </TableCell>
                          <TableCell>{t("Interpretation")}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {visibleResultSummaryRows.map((summaryRow: any) => (
                          <TableRow key={summaryRow.test}>
                            <TableCell>{t(summaryRow.test)}</TableCell>
                            <TableCell>
                              <input
                                type="text"
                                autoComplete="off"
                                className="form-control bg-transparent"
                                value={summaryRow.result}
                                onChange={(e) =>
                                  handleResultSummaryChange(
                                    summaryRow.fieldKey,
                                    e.target.value
                                  )
                                }
                                disabled={!isResultFieldEditable}
                              />
                            </TableCell>
                            <TableCell>{t(summaryRow.interpretation)}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-xl-12 col-lg-12 col-md-12 col-sm-12 rounded"
            style={{ border: "2px solid #7239ea" }}
          >
            <div className="card mb-4 border">
              <div className="card-header bg-light-info d-flex justify-content-between align-items-center px-4 min-h-40px">
                <h5 className="m-0 text-info">Controls</h5>
              </div>
              <div className="card-body py-md-4 py-3 px-4">
                <div className="d-flex mb-5 gap-2">
                  <button
                    id="ResultDataExpandAllPassButton"
                    className="btn btn-primary btn-sm fw-bold search d-block fs-12px h-30px py-0 fw-500"
                    onClick={() => changeControlsStatus("Pass")}
                  >
                    <span>{t("All Pass")}</span>
                  </button>
                  <button
                    id="ResultDataExpandAllFailButton"
                    className="btn btn-danger btn-sm fw-bold search d-block fs-12px h-30px py-0 fw-500"
                    onClick={() => changeControlsStatus("Fail")}
                  >
                    <span>{t("All Fail")}</span>
                  </button>
                </div>
                <div className="table_bordered overflow-hidden">
                  <TableContainer className="shadow-none">
                    <Table
                      stickyHeader
                      aria-label="sticky table collapsible"
                      className="plate-mapping-table mb-1"
                    >
                      <TableHead className="h-35px">
                        <TableRow>
                          <TableCell className="min-w-80px w-80px">
                            {t("Control Name")}
                          </TableCell>

                          <TableCell className="min-w-125px w-125px">
                            {t("CT Value")}
                          </TableCell>



                          <TableCell className="min-w-125px w-125px">
                            <label className="form-check form-check-inline form-check-solid m-0 fw-500">
                              <input
                                id="ResultDataExpandReRunCheckBox"
                                className="form-check-input"
                                type="checkbox"
                                checked={
                                  mControlsList.length > 0 &&
                                  mControlsList.length ===
                                  mainCheckboxes.controlCheckbox.length
                                }
                                onChange={(e) =>
                                  handleSetReRunControlsForAll(e.target.checked)
                                }
                              />
                              {t("Re-Run")}
                            </label>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {loading ? (
                          <TableCell colSpan={5} className="padding-0">
                            <Loader />
                          </TableCell>
                        ) : (
                          mControlsList?.map(
                            (data: any, controlsIndex: any) => (
                              <TableRow key={data.id}>
                                <TableCell
                                  id={`ControlsControlName_${controlsIndex}`}
                                >
                                  {data?.controlName}
                                </TableCell>

                                <TableCell
                                  id={`ControlsControlCtValue_${controlsIndex}`}
                                >
                                  <input
                                    id={`ControlsControlCtValueInput_${controlsIndex}`}
                                    type="text"
                                    autoComplete="off"
                                    className="form-control bg-transparent"
                                    value={data?.ctValue ?? ""}
                                    onChange={(e) =>
                                      handleControlsFieldChange(
                                        controlsIndex,
                                        "ctValue",
                                        e.target.value
                                      )
                                    }
                                    onKeyDown={(e) => {
                                      if (!isNumericKey(e.key)) {
                                        e.preventDefault();
                                      }
                                    }}
                                  />
                                </TableCell>


                                <TableCell
                                  id={`ControlsControlIsReRun_${controlsIndex}`}
                                >
                                  <label className="form-check form-check-inline form-check-solid m-0 fw-500">
                                    <input
                                      id={`ControlsControlIsReRunCheckBox_${controlsIndex}`}
                                      className="form-check-input"
                                      type="checkbox"
                                      checked={data?.isReRun}
                                      value={data?.isReRun}
                                      onChange={(e) =>
                                        handleControlsFieldChange(
                                          controlsIndex,
                                          "isReRun",
                                          e.target.checked
                                        )
                                      }
                                    />
                                  </label>
                                </TableCell>
                              </TableRow>
                            )
                          )
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </div>
            </div>
          </div>
          {mPathogensList?.map((item: any, panelIndex: any) => (
            <div
              className="col-xl-12 col-lg-12 col-md-12 col-sm-12 rounded mt-5"
              style={{ border: "2px solid #ffc700" }}
              key={item.id}
            >
              <div className="card border">
                <div className="card-body py-md-4 py-3 px-4">
                  <div className="d-flex gap-2 mb-2">
                    <button
                      id="ResultDataExpandFillUndetermined"
                      className="btn btn-success btn-sm fw-bold search d-block fs-12px h-30px py-0 fw-500"
                      onClick={() =>
                        ChangeOrganismStatus("Undetermined", item, panelIndex)
                      }
                    >
                      <span>{t("Fill Undetermined")}</span>
                    </button>
                    <PermissionComponent
                      moduleName="ID LIS"
                      pageName="Result Data"
                      permissionIdentifier="InvalidReport"
                    >
                      <button
                        id="ResultDataExpandFillInvalid"
                        className="btn btn-info btn-sm fw-bold search d-block fs-12px h-30px py-0 fw-500"
                        onClick={() =>
                          ChangeOrganismStatus("Invalid", item, panelIndex)
                        }
                      >
                        <span>{t("Fill Invalid")}</span>
                      </button>
                    </PermissionComponent>
                    {/* <button className="btn btn-danger btn-sm fw-bold search d-block fs-12px h-30px py-0 fw-500">
                      <span  >Inconclusive</span>
                    </button> */}
                  </div>
                  <h4 className="text-warning">{item?.panelName}</h4>
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                    <div className="table_bordered overflow-hidden position-relative">
                      <TableContainer className="shadow-none">
                        <Table
                          stickyHeader
                          aria-label="sticky table collapsible"
                          className="plate-mapping-table mb-1"
                        >
                          <TableHead className="h-40px">
                            <TableRow>
                              <TableCell className="min-w-250px w-250px">
                                {t("Organism")}
                              </TableCell>

                              <TableCell className="min-w-125px w-125px">
                                {t("CT Value")}
                              </TableCell>




                              <TableCell className="min-w-100px">
                                <label className="form-check form-check-inline form-check-solid m-0 fw-500">
                                  <input
                                    id="ResultDataExpandWoundPanelReRun2CheckBox"
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={
                                      item?.organisms.length > 0 &&
                                      item?.organisms.length ===
                                      mainCheckboxes.organismCheckbox.length
                                    }
                                    onChange={(e) =>
                                      handleSetReRunForAll(
                                        e.target.checked,
                                        panelIndex,
                                        "organism"
                                      )
                                    }
                                  />
                                  {t("Re-Run")}
                                </label>
                              </TableCell>
                              <TableCell className="min-w-250px">
                                {t("Comments")}
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody className="scroll-start">
                            {loading ? (
                              <TableCell colSpan={8} className="padding-0">
                                <Loader />
                              </TableCell>
                            ) : (
                              item?.organisms?.map(
                                (data: any, organismIndex: any) => (
                                  <TableRow key={data.id}>
                                    <TableCell
                                      id={`WoundPanelOrganism_${organismIndex + 1
                                        }`}
                                    >
                                      {data?.organism}
                                    </TableCell>

                                    <TableCell
                                      id={`WoundPanelCTValue_${organismIndex + 1
                                        }`}
                                    >
                                      <input
                                        id={`WoundPanelCTValueInput_${organismIndex + 1
                                          }`}
                                        type="text"
                                        autoComplete="off"
                                        className="form-control bg-transparent"
                                        value={data?.ctValue ?? ""}
                                        onChange={(e) =>
                                          handleFieldChange(
                                            panelIndex,
                                            organismIndex,
                                            "ctValue",
                                            e.target.value,
                                            "organism"
                                          )
                                        }
                                        onKeyDown={(e) => {
                                          if (!isNumericKey(e.key)) {
                                            e.preventDefault();
                                          }
                                        }}
                                      />
                                    </TableCell>




                                    <TableCell>
                                      <label className="form-check form-check-inline form-check-solid m-0 fw-500">
                                        <input
                                          id={`WoundPanelIsReRunCheckBox_${organismIndex + 1
                                            }`}
                                          className="form-check-input"
                                          type="checkbox"
                                          value={data?.isReRun}
                                          checked={data?.isReRun}
                                          onChange={(e) =>
                                            handleFieldChange(
                                              panelIndex,
                                              organismIndex,
                                              "isReRun",
                                              e.target.checked,
                                              "organism"
                                            )
                                          }
                                        />
                                      </label>
                                    </TableCell>
                                    <TableCell>
                                      <input
                                        id={`WoundPaneorganism_${organismIndex + 1
                                          }`}
                                        type="text"
                                        autoComplete="off"
                                        className="form-control bg-transparent"
                                        value={data?.comments}
                                        onChange={(e) =>
                                          handleFieldChange(
                                            panelIndex,
                                            organismIndex,
                                            "comments",
                                            e.target.value,
                                            "organism"
                                            // false,
                                          )
                                        }
                                      />
                                    </TableCell>
                                  </TableRow>
                                )
                              )
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                    {/* <div className='scroll-ended'></div> */}
                  </div>

                </div>
              </div>
            </div>
          ))}
          {/* <div
            className="col-xl-12 col-lg-12 col-md-12 col-sm-12 rounded mt-5"
            style={{ border: "2px solid #ffc700" }}
          >
            <div className="card border">
              <div className="card-body py-md-4 py-3 px-4">
                <label
                  htmlFor="ResultDataExpandInternalNotes"
                  className="text bold"
                >
                  {t("Internal Notes:")}
                </label>
                <textarea
                  id="ResultDataExpandInternalNotes"
                  className="form-control  h-80px mt-2"
                  name="lisNotes" // Name attribute for the text box
                  placeholder={t("Enter your Internal notes here")}
                  rows={5} // Increase the number of rows to increase the height
                  value={reportNotes.lisNotes}
                  onChange={(e) =>
                    handleFieldChangeTextArea(e.target.value, "lisNotes")
                  }
                />
                <div className="mt-3"></div>
                <label htmlFor="ResultDataExpandcriticalReport">
                  {t("Critical Report Notes:")}
                </label>
                <textarea
                  id="ResultDataExpandcriticalReport"
                  className="form-control h-80px mt-2"
                  name="criticalReport" // Name attribute for the text box
                  placeholder={t("Enter your critical report notes here")}
                  rows={5} // Increase the number of rows to increase the height
                  value={reportNotes.criticalReport}
                  onChange={(e) =>
                    handleFieldChangeTextArea(e.target.value, "criticalReport")
                  }
                />
              </div>
            </div>
          </div> */}
          <div className="mt-2 py-4 d-flex mb-5 gap-2">
            {filterData.tabId === 1 ? (
              <PermissionComponent
                moduleName="Oncology LIS"
                pageName="Result Data"
                permissionIdentifier="PublishandValidate"
              >
                <div className="d-flex gap-2">
                  <LoadButton
                    id={`PublishBottom`}
                    className="btn btn-success btn-sm fw-bold search d-block fs-12px h-30px py-0 fw-500"
                    loading={isPublishing}
                    btnText={t("Publish")}
                    loadingText="Processing....."
                    onClick={async () => {
                      if (
                        hasPermission === true &&
                        row?.graphImageFileBit === false
                      ) {
                        setShow(true);
                      } else {
                        await Publish(
                          requisitionId,
                          reqTypeId,
                          facilityId,
                          row?.requisitionOrderId
                        );
                      }
                    }}
                  />
                  <LoadButton
                    id={`ValidateBottom`}
                    className="btn btn-success btn-sm fw-bold search d-block fs-12px h-30px py-0 fw-500"
                    loading={isValidating}
                    btnText={t("Validate")}
                    loadingText="Processing....."
                    onClick={async () => {
                      if (
                        hasPermission === true &&
                        row?.graphImageFileBit === false
                      ) {
                        setShow(true);
                      } else {
                        await Validate(
                          requisitionId,
                          reqTypeId,
                          facilityId,
                          row?.requisitionOrderId
                        );
                      }
                    }}
                  />
                </div>
              </PermissionComponent>
            ) : null}
            {filterData.tabId === 2 ? (
              <PermissionComponent
                moduleName="Oncology LIS"
                pageName="Result Data"
                permissionIdentifier="PublishandValidate"
              >
                <LoadButton
                  id={`UnPublishValidateBottom`}
                  className="btn btn-secondary btn-sm fw-bold search d-block fs-12px h-30px py-0 fw-500"
                  loading={isUnPublishing}
                  btnText={t("UnPublish&Validate")}
                  loadingText="Processing....."
                  onClick={() => UnPublishAndValidate()}
                />
              </PermissionComponent>
            ) : null}
            <PermissionComponent
              moduleName="ID LIS"
              pageName="Result Data"
              permissionIdentifier="Preview"
            >
              <LoadButton
                id={`ResultDataPreviewBottom`}
                className="btn btn-warning btn-sm fw-bold search d-block fs-12px h-30px py-0 fw-500 text-white"
                loading={isPreviewing}
                btnText={t("Preview")}
                loadingText={t("Previewing")}
                onClick={() =>
                  OncologyLISReportView(
                    requisitionId,
                    reqTypeId,
                    facilityId,
                    row.requisitionOrderId
                  )
                }
              />
            </PermissionComponent>
            <PermissionComponent
              moduleName="ID LIS"
              pageName="Result Data"
              permissionIdentifier="Save"
            >
              <LoadButton
                id={`ResultDataExpandSaveBottom`}
                className="btn btn-primary btn-sm fw-bold search d-block fs-12px h-30px py-0 fw-500"
                loading={isSubmitting}
                btnText={t("Save")}
                loadingText={t("Saving")}
                onClick={() => SaveIdResultDataExpand()}
              />
            </PermissionComponent>
          </div>
        </div>
      </div>
      <Modal
        show={show}
        onHide={ModalhandleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton className="bg-light-primary m-0 p-5">
          <h4>{t("Publish & Validate")}</h4>
        </Modal.Header>
        <Modal.Body>
          {t("Graph file is not uploaded yet, do you want to Continue ?")}
        </Modal.Body>
        <Modal.Footer className="p-0">
          <button
            id={`IDResultDataModalPublishAndValidateCancel`}
            type="button"
            className="btn btn-secondary"
            onClick={ModalhandleClose}
          >
            {t("Cancel")}
          </button>
          <button
            id={`IDResultDataModalPublishAndValidateContinue`}
            type="button"
            className="btn btn-primary m-2"
            onClick={async () => {
              await Publish(
                requisitionId,
                reqTypeId,
                facilityId,
                row?.requisitionOrderId
              );
              // setDuplicate(false);
            }}
          >
            {t("Continue")}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default memo(ResultDataExpandableRow);
